export const INSIGHTS = {
    TOGGLE_INSIGHTS_BUTTON: "toggle-insights-button",
    COMPONENTS: {
        COLOR_INSIGHTS: "color-insights",
        STYLE_INSIGHTS: "style-insights",
        CATEGORY_INSIGHTS: "category-insights",
        SIZE_INSIGHTS: "size-insights",
    },
};
